import React from 'react';
import {Link} from 'gatsby';

export default function Navbar(props) {
  const [navbarStatus, setNavbarStatus] = React.useState(0);

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = (event) => {
    const currentScroll = window.pageYOffset;
    if (currentScroll < 20) setNavbarStatus(0);
    else if (currentScroll < window.innerHeight * 0.75) setNavbarStatus(1);
    else setNavbarStatus(2);
  };

  return (
    <div
      className={`flex items-center justify-between py-2 px-4 bg-white z-100 w-full transition-all duration-500 fixed ${
                navbarStatus == 0 ?
                    '' :
                    navbarStatus == 1 ?
                    '-translate-y-full transform ' :
                    '  shadow-primary top-0'
      } md:px-8`}
    >
      <div className="py-3">
        <div>
          <Link
            to="/"
            className=" font-semibold tracking-tighter text-2xl text-gray-800 md:font-bold"
          >
            {props.data.title}
          </Link>
        </div>
      </div>
      <div className="flex flex-grow-0 items-center py-3">
        <div className=" flex-row flex ">
          <ul className=" flex flex-row justify-end list-none font-bold text-gray-700">
            <li>
              <span className="cursor-pointer hover:text-about-primary">
                <Link to="/about">about me.</Link>
              </span>
            </li>
            <li className="pl-2 md:pl-8">
              <span className="cursor-pointer hover:text-about-primary">
                <Link to="/contact">contact.</Link>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
